import ReportsView from 'ui/ManagerFinance/ReportingBase/ReportsView'
import { reportForms, reportItems } from './constants'

const AccountingReports = () => {
	return <ReportsView reportItems={reportItems} reportForms={reportForms} />
}

export default AccountingReports
